module.exports = __webpack_public_path__ + "img/cd.3c126e6d.svg";